import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ImageCroppedEvent, ImageTransform, LoadedImage } from 'ngx-image-cropper';

declare var $: any;


@Component({
  selector: 'modal-image-cropper',
  templateUrl: './modal-image-cropper.component.html',
  styleUrls: ['./modal-image-cropper.component.css']
})
export class ModalImageCropperComponent implements OnInit {

  @Input() id: string = '';
  @Input() type: string = '';
  @Output() eventUploadPhotoCropped = new EventEmitter<EventUploadPhotoCropped>();
  @Output() eventSelectAnotherFile = new EventEmitter<any>();

  imageChangedEvent: any = '';
  croppedImage: any = '';

  private imageChangedEventName: string = '';
  public resizeToWidth: number = 1000;
  public resizeToHeight: number = 1000;
  public cropperMinWidth: number = 1000;
  public cropperMinHeight: number = 1000;
  public maintainAspectRatio: boolean = false;

  public scale = 1;
  public transform: ImageTransform = {};

  constructor() { }

  ngOnInit(): void {

    switch (this.type) {

      case 'inputEmployeePhoto':
        this.resizeToWidth = 150;
        this.resizeToHeight = 150;
        this.cropperMinWidth = this.resizeToWidth / 2;
        this.cropperMinHeight = this.resizeToHeight / 2;
        this.maintainAspectRatio = true;
        break;

        
      case 'inputEmployerPhoto':
        this.resizeToWidth = 480;
        this.resizeToHeight = 480;
        this.cropperMinWidth = this.resizeToWidth / 2;
        this.cropperMinHeight = this.resizeToHeight / 2;
        this.maintainAspectRatio = false;
        break;

      case 'inputEmployerProfileHeader':
        this.resizeToWidth = 2280;
        this.resizeToHeight = 400;
        this.cropperMinWidth = this.resizeToWidth / 3;
        this.cropperMinHeight = this.resizeToHeight / 3;
        this.maintainAspectRatio = true;
        break;

      case 'inputEmployerPrincipalPhoto':
        this.resizeToWidth = 1680;
        this.resizeToHeight = 980;
        this.cropperMinWidth = this.resizeToWidth / 3;
        this.cropperMinHeight = this.resizeToHeight / 3;
        this.maintainAspectRatio = true;
        break;

      case 'inputEmployerMemberPhoto':
        this.resizeToWidth = 480;
        this.resizeToHeight = 480;
        this.cropperMinWidth = this.resizeToWidth / 3;
        this.cropperMinHeight = this.resizeToHeight / 3;
        this.maintainAspectRatio = true;
        break;
    }
  }

  selectFile(event: EventSelectFile) {
    this.resetImage();
    this.imageChangedEventName = event.name;
    this.imageChangedEvent = event.event;
  }


  onClickUpload(event: MouseEvent) {
    event.preventDefault();
    this.eventUploadPhotoCropped.next({ croppedPhoto: this.croppedImage, name: this.imageChangedEventName })
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;

    console.log('imageCropped');

  }

  imageLoaded(image: LoadedImage) {
    // show cropper
    $(`#modal-${this.id}`).modal('show');
  }

  cropperReady() {
    // cropper ready
    console.log('cropperReady');
  }

  loadImageFailed(event) {
    // show message
    console.log('loadImageFailed');
    console.log(event);

  }

  onClickAnotherFile(event: MouseEvent) {
    event.preventDefault();
    this.eventSelectAnotherFile.next(null)

  }

  resetImage() {
    this.scale = 1;
    this.transform = {};
  }

  zoomOut() {
    this.scale -= .1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  zoomIn() {
    this.scale += .1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

}
